import { render, staticRenderFns } from "./showSingle.vue?vue&type=template&id=1ce7ee94&scoped=true&"
import script from "./showSingle.vue?vue&type=script&lang=js&"
export * from "./showSingle.vue?vue&type=script&lang=js&"
import style0 from "./showSingle.vue?vue&type=style&index=0&id=1ce7ee94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce7ee94",
  null
  
)

export default component.exports